import * as React from "react";

import KitsScreen from "../../../componets/KitsScreen";

const Storage = () => {
  return <KitsScreen type="storage" hideFooter disableKitSelection />;
};

export default Storage;
